import { SW_MEMBER_ID_STORAGE_KEY } from "../constants/index.js";
const updatePushSubscription = async ({
  memberId,
  accountId,
  notificationURI,
  notificationTestParam,
  publicUrl
}) => {
  try {
    if (!("serviceWorker" in navigator)) return;
    const sw = await navigator.serviceWorker.getRegistration(`${publicUrl}/service-worker.js`);
    if (!sw) return;
    const registration = await navigator.serviceWorker.ready;
    if (!registration) return;
    if (!registration.pushManager) {
      console.log("Push notifications are not supported in this browser");
      return;
    }
    if (!notificationURI) return;
    const params = new URLSearchParams(window.location.search);
    const notifClient = params.get(notificationTestParam ?? "");
    const notificationInfoResponse = await fetch(notificationURI + "/notification/info", { method: "GET" });
    const {
      result: { subscribeEndpoint, vapidKey }
    } = await notificationInfoResponse.json();
    if (!!subscribeEndpoint) {
      if (!sw.pushManager) {
        console.log("Push notifications are not supported in this browser");
        return;
      }
      let subscription = await sw.pushManager.getSubscription();
      if (!subscription && !!vapidKey) {
        let unsub = false;
        try {
          subscription = await sw.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: vapidKey
          });
        } catch (error) {
          if ("message" in error) {
            if (error.message.startsWith("Registration failed - A subscription with a different applicationServerKey")) {
              unsub = true;
            }
          }
        }
        if (unsub && !!subscription) {
          await subscription.unsubscribe();
        }
      }
      if (!!subscription) {
        const domain = window.location.hostname ?? "";
        try {
          await fetch(notificationURI + subscribeEndpoint, {
            method: "POST",
            body: JSON.stringify({
              subscription,
              accountId,
              client: notifClient ?? domain,
              memberId
            }),
            headers: {
              "Content-Type": "application/json"
            }
          });
          if (memberId) sessionStorage.setItem(SW_MEMBER_ID_STORAGE_KEY, memberId);
        } catch (error) {
          console.log(error);
        }
      }
    }
  } catch (e) {
    console.log("updatePushSubscription error ", e);
  }
};
export {
  updatePushSubscription
};
